import ObjectInterface from "../Interfaces/ObjectInterface";

export default class BadGuy implements ObjectInterface
{
    el: HTMLElement;
    speed: number;
    left: number;
    bottom: number;
    active: boolean = true;

    constructor(speed: number)
    {
        this.speed = speed;

        this.el = document.createElement('div');
        setInterval(() => {
            this.move();
        }, 500);

        this.left = this.el.getBoundingClientRect().left;
        this.bottom = this.el.getBoundingClientRect().bottom;

        let _this = this;
        document.getElementById('Game').addEventListener('GameOver', () => {
            _this.active = false;
        });
    }

    render(): HTMLElement
    {
        return this.el;
    }

    move()
    {
        if(!this.active) {
            return;
        }
        // I can get the players location, so now I can make the virus head
        // towards the player. I can increase the range of the random nums
        // and then have a switch statement that is biased to go in a new
        // direction towards the player.
        //
        // A range of 0-100
        // Player is located to the right of the virus
        // switch(0-25, 25-75, 76-80, 81-100), the direction i want the virus
        // to go would have the widest range, and the direction i don't want
        // the virus to go would have the smallest range.
        let playerLocation = document.getElementById('Player').getBoundingClientRect();
        let virusLocation = this.el.getBoundingClientRect();
        this.checkPosition(playerLocation, virusLocation);

        let x = playerLocation.x - virusLocation.x;
        let y = playerLocation.y - virusLocation.y;

        // DOMRect { x: 300, y: 463, width: 40, height: 80, top: 463, right: 340, bottom: 543, left: 300 }
        // DOMRect { x: 0.98333740234375, y: 492.98333740234375, width: 50.0333251953125, height: 50.0333251953125, top: 492.98333740234375, right: 51.01666259765625, bottom: 543.0166625976562, left: 0.98333740234375 }
        // 299.01666259765625 -29.98333740234375
        // console.log(playerLocation, virusLocation, x, y);

        let upLower     = 0;
        let upHigher    = 0;
        let downLower   = 0;
        let downHigher  = 0;
        let rightLower  = 0;
        let rightHigher = 0;
        let leftLower   = 0;
        let leftHigher  = 0;

        let upPadding    = 0;
        let downPadding  = 0;
        let rightPadding = 0;
        let leftPadding  = 0;

        // Check the absolute value of the difference of X and Y from player and
        // virus. Whichever is distance is greater, that indicates if we need to
        // move up/down or left/right. Then a positive/negative number will tell
        // us if we need to move down/left or right/up.
        if(Math.abs(x) > Math.abs(y)) {
            if(x > 0) {
                rightPadding = 1000;
            } else {
                leftPadding = 1000;
            }
        } else {
            if(y > 0) {
                downPadding = 1000;
            } else {
                upPadding = 1000;
            }
        }

        upHigher    = upLower     + 100 + upPadding;
        downLower   = upHigher    + 1;
        downHigher  = downLower   + 100 + downPadding;
        rightLower  = downHigher  + 1;
        rightHigher = rightLower  + 100 + rightPadding;
        leftLower   = rightHigher + 1;
        leftHigher  = leftLower   + 100 + leftPadding;

        let randomNumber = Math.floor(Math.random() * leftHigher) + 1;
        if(randomNumber >= upLower && randomNumber <= upHigher) {
            this.moveUp();
        }
        if(randomNumber >= downLower && randomNumber <= downHigher) {
            this.moveDown();
        }
        if(randomNumber >= rightLower && randomNumber <= rightHigher) {
            this.moveRight();
        }
        if(randomNumber >= leftLower && randomNumber <= leftHigher) {
            this.moveLeft();
        }
    }

    moveUp()
    {
        if((this.bottom + this.speed) + this.el.offsetHeight > window.innerHeight) {
            return;
        }
        this.bottom = this.bottom + this.speed;
        this.el.style.bottom = this.bottom.toString() + 'px';
    }

    moveRight()
    {
        if((this.left + this.speed) + this.el.offsetWidth > window.innerWidth) {
            return;
        }
        this.left = this.left + this.speed;
        this.el.style.left = this.left.toString() + 'px';
    }

    moveDown()
    {
        if((this.bottom - this.speed) < 0) {
            return;
        }
        this.bottom = this.bottom - this.speed;
        this.el.style.bottom = this.bottom.toString() + 'px';
    }

    moveLeft()
    {
        if((this.left - this.speed) < 0) {
            return;
        }
        this.left = this.left - this.speed;
        this.el.style.left = this.left.toString() + 'px';
    }

    checkPosition(player: DOMRect, virus: DOMRect): void
    {
        if (!(  player.right  < virus.left   ||
            player.left   > virus.right  ||
            player.bottom < virus.top    ||
            player.top    > virus.bottom)
        ) {
            document.getElementById('Game').dispatchEvent(new CustomEvent('GameOver'));
        }
    }
}
